import React from 'react';
import PropTypes from 'prop-types';
import UserRolesList from '../UserRolesList';
import PermissionsList from '../PermissionsList';

import { Map } from 'immutable';

import Form from '../Form';

class CreateRoleForm extends Form {
    static fieldsValidation = {};
    static propTypes = {};

    static defaultProps = {
        ...Form.defaultProps,
        permissions: Map()
    };

    constructor(props, context) {
        super(props, context);

        this.state = {
            ...this.state,
            data: props.role.toJS()
        };
    }

    UNSAFE_componentWillReceiveProps(props) {
        if (props.role !== this.props.role) {
            this.setState({
                data: props.role.toJS()
            });
        }
    }

    onSubmit(e, ...args) {
        e.preventDefault();
        super.onSubmit(e, ...args);
    }

    onRoleChange(permissions) {
        let { data } = this.state;

        data.grants = permissions;

        this.setState({ data });
    }

    renderForm() {
        const deleteButton = (
            <button onClick={ this.props.onDeleteRequest } type="button" className="btn">
                Delete
            </button>
        );

        return (
            <div className="edit-role-form">
                <div className="row">
                    <div className="col-12">
                        <h3>Permissions</h3>
                        <PermissionsList
                            grants={ this.props.role.get('grants') }
                            onRoleChange={ this.onRoleChange.bind(this)}
                            permissions={ this.props.permissions }
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 edit-role-form__menu">
                        <button type="submit" className="btn btn-primary">
                            Save role
                        </button>
                        { deleteButton }
                    </div>
                </div>
            </div>
        );
    }
}

export default CreateRoleForm;
